/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { isArray } from 'lodash';
import React, { useEffect, useState, useMemo, memo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Row,
  Label,
  Col,
} from 'reactstrap';
import { updateSipPri, getPbxStatus, updatePbxStatus } from '../../../../../actions/EpikBoxes';
import utils from '../../../../../lib/utils';

import AddPRINumber from '../../../../AddPRINumber';
import AvailablePRI from '../../../../AvailablePRI';
import BoxAutocomplete from '../../../BoxAutocomplete';
import SipPriDiagnostics from '../EpikboxSipPri/SipPriDiagnostics';
import diagnosticIcon from '../../../../../Res/Icon/priSipDiagnotic.png';
import { sipPriDiagnosticsPort } from '../../../../../actions/EpikBoxes';

import './BoxSip.css';
import { E911AddressModal } from './components/E911Modal';
import Spinner from '../../../../Spinner/Spinner';
import ConfirmationModal from '../../../../ConfirmationModal';
import Checkbox from '../../../../Checkbox';
import CustomWarning from '../../../../CustomWarning';
import { userRoles } from '../../../../../utils/constants';

const filterAlreadyAssignedNumbers = (numbers, selectedNumbers) => {
  return numbers.filter(num => {
    return !selectedNumbers.find(number => {
      return number.numRef === num._id;
    });
  });
};

export const EUpdateActions = {
  CLEAR_E911: '1',
  SUBMIT: '2',
  ADD_ASSIGN: '3',
  PBX_CHANGE: '4',
};
const PRI_COMMANDS_LIST = [
  { label: 'Software Diagnostic', value: 'SoftwareDiagnostic' },
  { label: 'dump', value: 'dump' },
  { label: 'Hardware Diagnostic', value: 'Hardware Diagnostic' },
  { label: 'Full-log -- undebug all', value: 'fullLog' },
  { label: 'Running log - condensed -- Debug voice summary', value: 'voice_summary' },
  { label: 'Running log - all -- debug voice verbose', value: 'active_call_monitoring' },
  { label: 'Running log - PRI -- Debug isdn l2-formatted', value: 'pri_isdn' },
  { label: 'PRI Signaling Status', value: 'priSignalStatus' },
  // { label: 'PRI Signaling Status', value: 'test_fun' },
]
const SIP_COMMANDS_LIST = [
  { label: "sofia Status", value: 'sofiaStatus' },
  { label: "show Calls Status", value: 'show Calls' },
]

const EpikboxSip = memo(
  ({
    title,
    onImportConfirm,
    importFinalList,
    onAssignAvailablePress,
    finalSelectedList,
    numberToFilter,
    updatePriSipSetting,
    numberSettings,
    MainTitle,
  }) => {
    const dispatch = useDispatch();
    const box = useSelector(state => state.AppState.boxDetails.box);
    const assignedNumbers = useSelector(state => state.AppState.obis.assignedNumbers);
    const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
    const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);
    const user = useSelector(state => state.AppState.user);

    const [warningModal, setWarningModal] = useState(false);
    const [modalStatus, setModalStatus] = useState(false);
    const [availableModal, setAvailableModal] = useState(false);
    const [isDiagnoticOpen, setIsDiagnoticOpen] = useState(false);
    const [isOpen, setIsopen] = useState(false);
    const [callerIdName, setCallerIdName] = useState('');
    const [callerIdNumber, setCallerIdNumber] = useState('');
    const [dtmfSettings, setDTMFSettings] = useState('');
    const [dnis, setDnis] = useState('');
    const [modifyNumberModal, setModifyNumberModal] = useState(false);
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [updatedSelectNumbers, setUpdatedSelectNumbers] = useState([]);
    const [isNumberModify, setIsNumberModify] = useState(null);
    const [priSipDiagnoticData, setPriSipDiagnoticData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pbx, setPbx] = useState(false);
    const [pbxWarning, setPbxWarning] = useState(false);
    const [boxDetails, setBoxDetails] = useState(box);

    useEffect(() => {
      setBoxDetails(box);
    }, [box]);

    const updateSipPriSettings_ = async (token, boxId, isPri, settings_) => {
      try {
        setIsLoading(true);
        await dispatch(updateSipPri(token, boxId, isPri, settings_));
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    const [isE911ModalOpen, setIsE911Modal] = useState(false);
    const [selectedE911Id, setSelectedE911Id] = useState('');
    const checkThirdOctet = parseInt(boxDetails?.vpnAddress?.split('.')[2], 10) >= 20;

    const numbers = useMemo(() => {
      const isSipModal = !!(MainTitle === 'SIP Trunking');
      const numbers_ = isSipModal
        ? sipSettings?.numberSettings?.numbers
        : priSettings?.numberSettings?.numbers;
      return numbers_?.length
        ? numbers_?.map(val => ({
          number: val.number,
          _id: val.numRef,
        }))
        : [];
    }, [sipSettings, priSettings]);

    const settings = useMemo(() => {
      const isSipModal = !!(MainTitle === 'SIP Trunking');
      return isSipModal ? sipSettings : priSettings;
    }, [sipSettings, priSettings]);

    const [selectedE911Number, setSelectedE911Number] = useState('');

    const initialStateSet = () => {
      setSelectedE911Number(settings?.e911Number || '');
      setCallerIdName(settings?.numberSettings?.callerIdName);
      setCallerIdNumber(settings?.numberSettings?.callerIdNumber);
      setDnis(settings?.numberSettings?.dnis);
      setUpdatedSelectNumbers(settings?.numberSettings?.numbers || []);
      setDTMFSettings(settings?.numberSettings?.dtmfType || 'Inband');
    }
    useEffect(() => {
      initialStateSet()
    }, [sipSettings, priSettings]);

    const onCancel = useCallback(() => {
      setIsE911Modal(false);
    }, []);

    const handleNumbersAutoComplete = e => {
      const { suggestion, value } = e || {};
      if (suggestion) {
        setSelectedE911Number(value);
        setIsE911Modal(true);
        setSelectedE911Id(suggestion?._id);
      }
    };

    const updateNumberSettings = async (
      assignedNum,
      unassignedNumbers,
      mode = EUpdateActions.SUBMIT,
    ) => {
      const isPRI = !(MainTitle === 'SIP Trunking');
      const numberSetting = {
        callerIdName,
        callerIdNumber,
        dnis,
        numbers: isArray(assignedNum) ? assignedNum : settings?.numberSettings?.numbers,
        unassignedNumbers,
        dtmfType: dtmfSettings,
      };
      const updatedSettings = { ...settings };
      updatedSettings.e911Number = selectedE911Number;
      if (mode === EUpdateActions.CLEAR_E911) {
        const shippedAddress_ = {
          street1: '',
          street2: '',
          attn: '',
          city: '',
          state: '',
          zip: '',
        };
        updatedSettings.shippedAddress = { ...shippedAddress_ };
        updatedSettings.e911Number = '';
      }
      updatedSettings.numberSettings = { ...numberSetting };
      const token = utils.getAuthToken();
      if (mode === EUpdateActions.SUBMIT && !selectedE911Number) {
        toast.error('Please Enter E911 Number');
        return;
      }
      if( mode === EUpdateActions.PBX_CHANGE ){
        updatedSettings.pbx = !settings.pbx
      }
      await updateSipPriSettings_(token, boxDetails._id, isPRI, updatedSettings);
      if (mode === EUpdateActions.CLEAR_E911 || mode === EUpdateActions.ADD_ASSIGN) return;
      setIsopen(!isOpen);
      setWarningModal(true);
    };

    const getSelectNumber = (mode = EUpdateActions.ADD_ASSIGN) => {
      let finalList = [];
      let unassignedNumbers = null;
      if (isNumberModify) {
        finalList = updatedSelectNumbers?.filter(item => selectedNumbers?.includes(item.numRef));
        unassignedNumbers = updatedSelectNumbers?.filter(
          item => !selectedNumbers?.includes(item.numRef),
        );
      }
      if (!isNumberModify) {
        const values = assignedNumbers?.filter(item => selectedNumbers?.includes(item._id));
        const dummyArry = [...updatedSelectNumbers, ...values];

        const removeDuplicate = dummyArry.filter(
          (thing, index, self) => index === self.findIndex(t => t.number === thing.number),
        );

        finalList = removeDuplicate?.map(items => {
          return {
            numRef: items?._id || items?.numRef,
            number: items?.number,
            numberType: title?.toLowerCase(),
          };
        });
      }
      setUpdatedSelectNumbers([...finalList]);
      updateNumberSettings([...finalList], unassignedNumbers, mode);
    };

    const handleClearE911Num = () => {
      getSelectNumber(EUpdateActions.CLEAR_E911);
    };

    /*
    redundant useEffect. Creating issues
    useEffect(() => {
      setCallerIdName(numberSettings?.callerIdName || '');
      setCallerIdNumber(numberSettings?.callerIdNumber || '');
      setDnis(dnis || numberSettings?.dnis || 3);
      setUpdatedSelectNumbers(numberSettings?.numbers || []);
      setDTMFSettings(numberSettings?.dtmfType || 'Inband');
    }, [numberSettings]);
    */
    const handlePriSipDiagnotic = () => {
      setIsDiagnoticOpen(true);
      if (title === 'PRI') {
        setPriSipDiagnoticData(PRI_COMMANDS_LIST);
      }
      if (title === 'SIP') {
        setPriSipDiagnoticData(SIP_COMMANDS_LIST);
      }
    };

    const onPbxSave = () => {
      setPbxWarning(true);
    };

    const allowPbx = async () => {
      const vpn = boxDetails?.vpnAddress;
      const token = utils.getAuthToken();
      const bid = boxDetails?._id;
      setIsLoading(true);
      await updateNumberSettings(undefined,undefined, EUpdateActions.PBX_CHANGE)
      setIsLoading(false);
      setPbxWarning(false);
    };
    return (
      <>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="boxPortContainer">
            <div onClick={() => setIsopen(!isOpen)}>
              <div className="portLabel" id={title?.toLowerCase()}>{title}</div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>CID Number</h5>
                </div>
                <span>{settings?.numberSettings?.callerIdNumber || '-'}</span>
              </div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>DNIS</h5>
                </div>
                <span>{settings?.numberSettings?.dnis || '-'}</span>
              </div>
              <div className="portInfo">
                <div className="infoLabel">
                  <h5>Numbers Assigned</h5>
                </div>
                <span>{settings?.numberSettings?.numbers?.length.toString() || '0'}</span>
              </div>
            </div>
            {checkThirdOctet && (
              (title === 'PRI' || title === 'SIP') && (
                user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin ? (
                  <div className="icon-right">
                    <p onClick={handlePriSipDiagnotic}>
                      <img src={diagnosticIcon} style={{ width: '18px' }} alt="Diagnostic Icon" />
                    </p>
                  </div>
                ) : null
              )
            )}


            <Modal isOpen={isOpen}>
              <ModalHeader>{MainTitle}</ModalHeader>
              <ModalBody>
                <Row className="number-list-row">
                  <Col md={5} sm={6}>
                    <h6 className="type-header">Number Assignment</h6>
                  </Col>
                </Row>
                  {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) && 
                    <div className=" under-line">
                      <Row className="number-list-row">
                        <Col md={6} sm={6} className="mb-2">
                          <Button
                            color="primary"
                            onClick={() => {
                              onAssignAvailablePress();
                              setIsNumberModify(false);
                              setAvailableModal(true);
                              setSelectedNumbers([]);
                            }}
                          >
                            Assign Available Numbers
                          </Button>
                        </Col>
                        <Col md={6} sm={6} className="mb-2">
                          <Button
                            color="secondary"
                            onClick={() => {
                              onAssignAvailablePress();
                              setModifyNumberModal(true);
                              setIsNumberModify(true);
                              setSelectedNumbers([]);
                            }}
                          >
                            Modify Assigned Numbers
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  }
                <div className="bd-container height-list">
                    {settings?.numberSettings?.numbers?.length ? (
                      <Row className="number-list-row">
                        <Col md={{ size: 12 }} sm={{ size: 6 }}>
                          {numbers?.map(item => {
                            return <Label style={{ marginRight: '25px' }}>{item?.number}</Label>;
                          })}
                        </Col>
                      </Row>
                    ) : (
                      <div>
                        <h6>No Assigned numbers</h6>
                      </div>
                    )}
                </div>
                {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) &&
                    <>
                      <Row style={{ paddingTop: 25, borderTop: '1px solid #777' }}>
                        <Col sm={6} md={4}>
                          <Label className="sip-input-label">DNIS</Label>
                        </Col>
                        <Col sm={6} md={5}>
                          <Input
                            type="select"
                            value={dnis}
                            className="filter-append-dropdown"
                            onChange={e => setDnis(e.currentTarget.value)}
                          >
                            <option key="3" value="3">
                              3
                            </option>
                            <option key="4" value="4">
                              4
                            </option>
                            <option key="5" value="5">
                              5
                            </option>
                            <option key="6" value="6">
                              6
                            </option>
                            <option key="7" value="7">
                              7
                            </option>
                            <option key="8" value="8">
                              8
                            </option>
                            <option key="9" value="9">
                              9
                            </option>
                            <option key="10" value="10">
                              10
                            </option>
                          </Input>
                        </Col>
                      </Row>
                      <div style={{ paddingBottom: '20px', paddingTop: '15px' }}>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col>
                            <Label className="sip-heading ">Outbound Caller ID</Label>
                          </Col>
                        </Row>
                        <div className="sip-section ">
                          <Row className="sip-input">
                            <Col sm={6} md={6}>
                              <Label className="ml-3 mt-2" check>
                                <Input
                                  disabled={settings?.pbx}
                                  type="checkbox"
                                  checked={settings?.pbx}
                                // value={item?._id || item.numRef}
                                />
                                Allow Caller ID from PBX
                              </Label>
                            </Col>
                            <Col sm={6} md={4}>
                              <Button color="primary" onClick={onPbxSave}>
                              {!settings?.pbx ? "Allow" : "Disable"} PBX
                            </Button>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm={12} md={12}>
                            <Label for="error" className="pbx-error">
                              {pbxStatusError}
                            </Label>
                          </Col>
                        </Row> */}
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label for="number" className="sip-input-label">
                              Number
                            </Label>
                          </Col>
                          <Col sm={6} md={5}>
                            <Input
                              disabled={settings?.pbx}
                              onChange={e => setCallerIdNumber(e.target.value)}
                              required
                              value={callerIdNumber}
                              type="text"
                              name="number"
                            />
                          </Col>
                        </Row>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label className="sip-input-label">DTMF Settings</Label>
                          </Col>
                          <Col sm={6} md={5}>
                            <Input
                              type="select"
                              value={dtmfSettings}
                              className="filter-append-dropdown"
                              onChange={e => setDTMFSettings(e.currentTarget.value)}
                            >
                              <option key="Edge Device Name" value="Inband">
                                Inband
                              </option>
                              <option key="Status" value="RFC 2833">
                                RFC 2833
                              </option>
                            </Input>
                          </Col>
                        </Row>
                        <Row style={{ paddingTop: '5px' }}>
                          <Col sm={6} md={4}>
                            <Label className="sip-input-label">E911 Number</Label>
                          </Col>
                          <Col sm={5}>
                            {numbers?.length > 0 ? (
                              <>
                                <BoxAutocomplete
                                  placeholder="Filter Numbers"
                                  searchTerm={selectedE911Number}
                                  numbers={numbers}
                                  onChange={handleNumbersAutoComplete}
                                />
                              </>
                            ) : (
                              <Label className="sip-input-label one-line-text">
                                {' '}
                                No Assigned number Selected{' '}
                              </Label>
                            )}
                          </Col>
                          <Col sm={2}>
                            {numbers.length > 0 && (
                              <Button color="primary" onClick={handleClearE911Num}>
                                Clear
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </div>
                      </div>
                    </>
                }  
                {/* <div style={{ paddingBottom: '20px' }}>
                  <Row style={{ paddingTop: '5px' }}>
                    <Col>
                      <Label className="sip-heading ">Failore Settings</Label>
                    </Col>
                  </Row>
                  <div className="sip-secition">
                    <Row style={{ paddingTop: '5px' }}>
                      <Col sm={6} md={4}>
                        <Label className="sip-input-label">Failore Device #1</Label>
                      </Col>
                      <Col sm={6} md={5}>
                        <Input
                          type="select"
                          value={failoreDevice1}
                          className="filter-append-dropdown"
                          onChange={e => setFailoreDevice1(e.currentTarget.value)}
                        >
                          <option key="Edge Device Name" value="IP Auth">
                            IP Auth
                          </option>
                          <option key="Status" value="Username/Password">
                            Username/Password
                          </option>
                          ]
                        </Input>
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: '5px' }}>
                      <Col sm={6} md={4}>
                        <Label className="sip-input-label">Failore Device #2</Label>
                      </Col>
                      <Col sm={6} md={5}>
                        <Input
                          type="select"
                          value={failoreDevice2}
                          className="filter-append-dropdown"
                          onChange={e => setFailoreDevice2(e.currentTarget.value)}
                        >
                          <option key="Edge Device Name" value="IP Auth">
                            IP Auth
                          </option>
                          <option key="Status" value="Username/Password">
                            Username/Password
                          </option>
                        </Input>
                      </Col>
                    </Row>
                  </div>
                </div> */}
              </ModalBody>
              {/*  footer */}
              <ModalFooter>
                <Button
                  outline
                  color="secondary"
                  onClick={() => {
                    setIsopen(!isOpen);
                    setIsNumberModify(null);
                    initialStateSet()
                  }}
                >
                    {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmin) ? 'Cancel' : 'Close'}
                </Button>
                {(user.role !== userRoles.admin && user.role !== userRoles.enterpriseAdmins) && 
                   <Button color="primary" onClick={updateNumberSettings}> Submit  </Button>
                }
              </ModalFooter>
            </Modal>
            <AddPRINumber
              data={boxDetails}
              importNumberList={importFinalList}
              isOpen={modalStatus}
              onCancel={() => {
                setModalStatus(false);
                setIsNumberModify(null);
              }}
              onConfirm={() => {
                onImportConfirm();
                setModalStatus(false);
              }}
            />
            <SipPriDiagnostics
              data={priSipDiagnoticData}
              title={title}
              isOpen={isDiagnoticOpen}
              box={boxDetails}
              setIsOpen={setIsDiagnoticOpen}
            />

            <AvailablePRI
              // phone={this.props.phone}
              setSelectedNumbers={setSelectedNumbers}
              numberToFilter={numberToFilter}
              finalSelectedList={finalSelectedList}
              data={filterAlreadyAssignedNumbers(assignedNumbers, updatedSelectNumbers)}
              isOpen={availableModal}
              onCancel={() => setAvailableModal(false)}
              onConfirm={() => {
                getSelectNumber(EUpdateActions.ADD_ASSIGN);
                setAvailableModal(false);
              }}
            />

            <AvailablePRI
              // phone={this.props.phone}
              selectedNumbers={selectedNumbers}
              setSelectedNumbers={setSelectedNumbers}
              numberToFilter={numberToFilter}
              isNumberModify={isNumberModify}
              finalSelectedList={finalSelectedList}
              data={updatedSelectNumbers}
              isOpen={modifyNumberModal}
              onCancel={() => setModifyNumberModal(false)}
              onConfirm={() => {
                getSelectNumber(EUpdateActions.ADD_ASSIGN);
                setModifyNumberModal(false);
              }}
            />
            {isE911ModalOpen && (
              <E911AddressModal
                isOpen={isE911ModalOpen}
                onCancel={onCancel}
                numberId={selectedE911Id}
                numberTitle={selectedE911Number}
                isTypeSip={!!(MainTitle === 'SIP Trunking')}
                settings={settings}
              />
            )}
          </div>
        )}
        <ConfirmationModal
          bodyText="Please reboot this device for changes to take effect."
          isOpen={warningModal}
          onCancel={() => setWarningModal(false)}
          ignoreConfirmButton
          close
        />
        <CustomWarning
          // loading={activateLoading || saveLoading}
          isOpen={pbxWarning}
          onCancel={() => setPbxWarning(false)}
          onConfirm={allowPbx}
        >
          The settings will be saved and the page will need to be refreshed to commit this change.
          Are you sure you want to proceed?
        </CustomWarning>
      </>
    );
  },
);

export default EpikboxSip;
